import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function CancelIcon({ classes }) {
  const styles = useStyles();
  const iconClasses = cn(styles.cancelIcon, classes);

  return (
    <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" height="20" width="20">
      <path d="M7.021 14.188 10 11.208 12.979 14.188 14.208 12.958 11.229 10 14.208 7.021 12.979 5.792 10 8.771 7.021 5.792 5.812 7 8.792 10 5.812 12.979ZM10 18.333Q8.271 18.333 6.75 17.677Q5.229 17.021 4.104 15.896Q2.979 14.771 2.323 13.25Q1.667 11.729 1.667 10Q1.667 8.271 2.323 6.75Q2.979 5.229 4.104 4.104Q5.229 2.979 6.75 2.323Q8.271 1.667 10 1.667Q11.729 1.667 13.25 2.323Q14.771 2.979 15.896 4.104Q17.021 5.229 17.677 6.75Q18.333 8.271 18.333 10Q18.333 11.729 17.677 13.25Q17.021 14.771 15.896 15.896Q14.771 17.021 13.25 17.677Q11.729 18.333 10 18.333ZM10 10Q10 10 10 10Q10 10 10 10Q10 10 10 10Q10 10 10 10Q10 10 10 10Q10 10 10 10Q10 10 10 10Q10 10 10 10ZM10 16.583Q12.729 16.583 14.656 14.656Q16.583 12.729 16.583 10Q16.583 7.271 14.656 5.344Q12.729 3.417 10 3.417Q7.271 3.417 5.344 5.344Q3.417 7.271 3.417 10Q3.417 12.729 5.344 14.656Q7.271 16.583 10 16.583Z" />
    </svg>
  );
}

CancelIcon.propTypes = {
  classes: PropTypes.string,
};

CancelIcon.defaultProps = {
  classes: '',
};

export default CancelIcon;
